export default __webpack_public_path__ + "static/media/rentatoy-logo.5bfbcece.png";